import { Right } from "constants/right";
import { accountIsCanceled, isExpired } from "helpers/subscription";
import { IWithAgentsState } from "store/entities/agents";
import { IWithBillingEntitiesState, getBilling } from "store/entities/billing";
import { IWithIntegrationsState, selectIsManagedByShopify, selectIsShopifyTrial } from "store/entities/integrations";
import { IWithSubscriptionsState, selectCurrentSubscription } from "store/entities/subscriptions";
import { IWithSessionState, hasRight } from "store/features/session";

import { ISort } from "./interfaces";
import { ITeamsViewState } from "./reducer";

export interface IWithTeamsViewState {
  views: {
    teams: ITeamsViewState;
  };
}

export function getSelectedTeamId(state: IWithTeamsViewState): string {
  return state.views.teams.selectedTeamId;
}

export function getFocusedColumn(state: IWithTeamsViewState): number {
  return state.views.teams.focusedColumn;
}

export function getListSorting(state: IWithTeamsViewState): ISort {
  return state.views.teams.sort;
}

export function selectCanAddTeams(
  state: IWithTeamsViewState &
    IWithSessionState &
    IWithSubscriptionsState &
    IWithBillingEntitiesState &
    IWithAgentsState &
    IWithIntegrationsState
): boolean {
  const hasManageTeamsRight = hasRight(state, Right.ManageTeams);
  const currentSubscription = selectCurrentSubscription(state);
  const billing = getBilling(state);
  const isShopifyTrial = selectIsShopifyTrial(state);
  const isManagedByShopify = selectIsManagedByShopify(state);

  return (
    currentSubscription &&
    !isExpired(currentSubscription) &&
    !accountIsCanceled(billing, isShopifyTrial, isManagedByShopify) &&
    hasManageTeamsRight
  );
}
